const HANDLER = '_clickaway';

/**
 * Check if parent contains child element
 * @param {HTMLElement} parent
 * @param {HTMLElement} child
 */
function contains(parent, child) {
  do {
    if (parent === child) return true;
    child = child.parentNode;
  } while (child.parentNode);

  return false;
}

/**
 * Bind directive to element
 * @param {HTMLElement} el
 * @param {Object} binding
 */
function bind(el, binding) {
  if (typeof binding.value !== 'function') return;

  // Assign function to element to have access to it for unbind
  el[HANDLER] = function(event) {
    if (!contains(el, event.target)) binding.value();
  };

  document.addEventListener('click', el[HANDLER], false);
}

function unbind(el) {
  // Detach event listener and remove listen function from element
  document.removeEventListener('click', el[HANDLER]);
  delete el[HANDLER];
}

export default {
  bind,
  unbind,
  update(el, binding) {
    if (binding.value === binding.oldValue) return;
    bind(el, binding);
  },
};
